import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  MYAPPS: {
    id: 'MyApps.myApps',
    defaultMessage: 'My Apps',
    description: '[Type: Label][Vis.: low] - My Apps link in main navigation',
  },
});

const MyApps = () => <MainNavButton href="/apps/" label={t(COPY.MYAPPS)} />;

export default MyApps;
export { MyApps };
